<ion-header
  [class.ion-header-modal-mobile]="isMobile"
  [class.ion-header-modal-desktop]="!isMobile"
>
  <ion-toolbar>
    <ion-label data-cy="share-via-email-modal-title">{{
      'i18n.sharePDP.shareViaEmail' | translate
    }}</ion-label>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="!isMobile"
        data-cy="share-via-email-modal-dismiss-btn"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  [class.ion-content-modal-mobile]="isMobile"
  [class.ion-content-modal-desktop]="!isMobile"
>
  <form
    data-cy="share-via-email-modal-form"
    [formGroup]="shareForm"
    (ngSubmit)="shareDocument()"
  >
    <div class="content">
      <div class="first-row">
        <ion-item lines="none" class="no-background">
          <ion-label
            data-cy="share-via-email-modal-documentToShare-label"
            position="stacked"
            class="document-to-share"
            >{{ 'i18n.sharePDP.documentToShare' | translate }}:</ion-label
          >
          <div
            data-cy="share-via-email-modal-documentToShare-fileName-label"
            class="document-name"
          >
            {{ documentName }}
          </div>
        </ion-item>
        <ion-item
          lines="none"
          class="no-background"
          data-cy="share-via-email-modal-format-section"
          *ngIf="shareAction === 'ShareProductCompare'"
        >
          <ion-label
            data-cy="share-via-email-modal-documentToShare-label"
            position="stacked"
            class="document-to-share"
            >{{ 'i18n.sharePDP.selectFormat' | translate }}:</ion-label
          >
          <ion-select
            aria-labelledby="download-format"
            interface="popover"
            [interfaceOptions]="selectPopoverOptions"
            formControlName="fileFormat"
            (ionFocus)="isFileTypePopoverOpen = true"
            toggleIcon="chevron-down-outline"
            expandedIcon="chevron-up-outline"
          >
            <ion-select-option value="pdf">PDF</ion-select-option>
            <ion-select-option value="csv">CSV</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      <ion-item lines="none" class="no-background">
        <ion-label
          data-cy="share-via-email-modal-emailTo-label"
          position="stacked"
          class="item-title"
          >{{ 'i18n.sharePDP.to' | translate }}</ion-label
        >
        <div class="emailTo-container">
          <div class="textarea-container">
            <ion-textarea
              (keydown)="onEmailKeydown($event)"
              (ionInput)="checkEmailLines()"
              data-cy="share-via-email-modal-emailTo-input"
              #emailTextarea
              aria-label="To"
              maxlength="500"
              formControlName="emailTo"
              [placeholder]="'i18n.sharePDP.toPlaceholder' | translate"
              [ngClass]="
                emailTo.invalid && emailTo.touched
                  ? 'textarea-error' +
                    (isCollapsed ? ' textarea-collapsed' : '')
                  : isCollapsed
                    ? 'textarea-collapsed'
                    : ''
              "
              autoGrow="true"
            >
            </ion-textarea>
            <div
              data-cy="share-via-email-modal-emailTo-charCount"
              [ngClass]="
                (emailTo.invalid && emailTo.touched) ||
                emailTo?.value?.length > 500
                  ? 'char-count-error'
                  : ''
              "
              class="char-count"
            >
              {{ emailTo.value?.length || 0 }}/500
            </div>
            <div
              data-cy="share-via-email-modal-emailTo-errorMsg"
              *ngIf="emailTo.invalid && emailTo.touched"
              class="error-msg"
            >
              <ng-container *ngIf="emailTo.errors?.maxEmailsExceeded">{{
                'i18n.sharePDP.errorExceedsEmailAddresses' | translate
              }}</ng-container>
              <ng-container *ngIf="emailTo.errors?.invalidEmails">{{
                'i18n.sharePDP.errorEmailAddressInvalid' | translate
              }}</ng-container>
            </div>
          </div>
          <div *ngIf="isCollapsed">
            <ion-button
              data-cy="share-via-email-modal-emailTo-expand-btn"
              class="usf-outline-black-dsktp-tblt-modal-button"
              (click)="toggleCollapse()"
              slot="end"
            >
              +{{ collapsedEmails.length }}
              {{ 'i18n.sharePDP.others' | translate }}
            </ion-button>
          </div>
        </div>
      </ion-item>

      <ion-item lines="none" class="no-background">
        <ion-label
          data-cy="share-via-email-modal-message-label"
          position="stacked"
          class="item-title"
          >{{ 'i18n.sharePDP.message' | translate }}</ion-label
        >
        <ion-textarea
          (keydown)="onEmailKeydown($event)"
          data-cy="share-via-email-modal-message-input"
          aria-label="Message"
          formControlName="message"
          maxlength="200"
          [placeholder]="'i18n.sharePDP.messagePlaceholder' | translate"
          [ngClass]="message.invalid && message.touched ? 'textarea-error' : ''"
          class="message-text"
        ></ion-textarea>
        <div
          data-cy="share-via-email-modal-message-charCount"
          [ngClass]="
            (message.invalid && message.touched) || message?.value?.length > 200
              ? 'char-count-error'
              : ''
          "
          class="char-count"
        >
          {{ message.value?.length || 0 }}/200
        </div>
        <div
          data-cy="share-via-email-modal-message-errorMsg"
          *ngIf="message.invalid && message.touched"
          class="error-msg"
        >
          <ng-container *ngIf="message.errors?.invalidChars">{{
            'i18n.sharePDP.errorInvalidChars' | translate
          }}</ng-container>
        </div>
      </ion-item>

      <ion-item lines="none" class="no-background">
        <ion-label
          data-cy="share-via-email-modal-senderDescription-label"
          class="share-via-email-label content-label"
        >
          {{ 'i18n.sharePDP.senderDescription' | translate }}
        </ion-label>
      </ion-item>
      <div class="checkbox-container">
        <ion-item
          lines="none"
          class="no-background"
          *ngIf="
            shareAction === 'SharePDP' || shareAction === 'ShareProductCompare'
          "
        >
          <ion-checkbox
            data-cy="share-via-email-modal-includeProductPrices-checkbox"
            aria-label="Include Product Prices"
            formControlName="includeProductPrices"
          ></ion-checkbox>
          <ion-label
            data-cy="share-via-email-modal-includeProductPrices-label"
            class="content-label"
            >{{ 'i18n.sharePDP.includeProductPrices' | translate }}</ion-label
          >
        </ion-item>
        <ion-item lines="none" class="no-background">
          <ion-checkbox
            data-cy="share-via-email-modal-sendMeACopy-checkbox"
            aria-label="Send me a copy"
            formControlName="sendCopy"
          ></ion-checkbox>
          <ion-label
            data-cy="share-via-email-modal-sendMeACopy-label"
            class="content-label"
            >{{ 'i18n.sharePDP.sendCopy' | translate }}</ion-label
          >
        </ion-item>
      </div>
    </div>
  </form>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="share-via-email-modal-cancel-btn"
        [class.usf-outline-green-mobile-modal-button]="isMobile"
        [class.usf-outline-green-dsktp-tblt-modal-button]="!isMobile"
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="share-via-email-modal-share-btn"
        [class.usf-fill-green-dsktp-tblt-modal-button]="
          !isMobile && !shareForm.invalid
        "
        [class.usf-fill-disabled-dsktp-tblt-modal-button]="
          !isMobile && shareForm.invalid
        "
        [class.usf-fill-green-mobile-modal-button]="isMobile"
        [disabled]="shareForm.invalid"
        (click)="shareDocument()"
      >
        {{ 'i18n.common.share' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
